<template>
  <el-dialog  :visible.sync="visible" size="tiny">
    <el-form label-position="top" :model="formDialog"  ref="formDialog" label-width="120px">

      <el-form-item label="设置线索购买价格（设置成功后立刻生效）" prop="price" :rules="[{ required: true, message: '价格不能为空'},{ validator: priceValidator, trigger: 'blur'}]">
        <el-input v-model="formDialog.price" placeholder="请输入金额(支持两位小数)"></el-input>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="validateFrom('formDialog',save)">提 交</el-button>
      <el-button @click="hide()">取 消</el-button>
    </div>

  </el-dialog>
</template>

<script>
import clueModel from '../../../framework/models/clueModel'
import BasicPager from '../../../mixins/BasicPager'
export default {
  name: 'save-clue-price-dialog',
  extends: BasicPager,
  data: function () {
    let priceValidator = (rule, value, callback) => {
      let match = value.match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        callback(new Error('小数点只能保留两位哦！'))
      } else {
        callback()
      }
    }

    return {
      priceValidator: priceValidator,
      formDialog: {
        price: null
      },
      mode: 'add',
      visible: false
    }
  },
  created: function () {
    this.getPrice()
  },
  methods: {
    onAreaChanged: function (area, label) {
      this.formDialog.area = label
    },
    getPrice: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.formDialog.price = dataInfo.datas
        }
      }
      clueModel.getClueSettlement(this, listener)
    },
    save: function () {
      let _this = this
      let params = {
        clueSettlement: _this.formDialog.price
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message({
            type: 'success',
            message: '线索单价设置成功！'
          })
          _this.hide()
        }
      }
      clueModel.editClueSettlement(this, params, listener)
    },
    show: function (dataItem) {
      this.visible = true
    },
    handleSuccess: function () {
      this.loadList()
    },
    hide: function () {
      this.visible = false
    }
  }
}
</script>
